.ux-iws-stateful-downloads {
    &__details {
        display: flex;
        flex-flow: row wrap;
        align-items: flex-start;
        justify-content: stretch;
    }

    &__cta {
        display: flex;
        flex-flow: row nowrap;
        flex: 1 0 auto;
        margin-bottom: 30px;
        justify-content: flex-end;
        align-self: flex-end;
    }

    &__field {
        display: block;
        flex: 0 0 auto;
        margin: 0 30px 30px 0;
    }

    &__field-label {
        display: block;
        margin: 0;
    }

    &__field-value {
        display: block;
        margin: 0;
        color: #727272;
    }
}
